module.exports = __webpack_public_path__ + "img/groovy.5ca077bf.svg";